<app-indicator-filter></app-indicator-filter>
<p-divider></p-divider>
<p-listbox
  class="app-set-list"
  [options]="options()"
  [(ngModel)]="selectedSet"
  optionLabel="set.name"
  optionValue="set"
  optionDisabled="disabled"
  dataKey="_id"
  (onChange)="selectSet()"
  styleClass="w-full"
  [listStyle]="{ height: '25rem' }">
  <ng-template pTemplate="header">
    <app-pick-list-header
      title="Indikatorensets"
      [count]="options().length"
      subtitle="Wählen Sie das Set, dem die Indikatoren zugeordnet werden sollen.">
      <span end>
        Gewählt:
        <strong class="text-color">{{ selectedSet?.name ?? '–' }}</strong>
      </span>
    </app-pick-list-header>
  </ng-template>
  <ng-template let-option pTemplate="item">
    <div class="pl-row">
      <i class="fas fa-ruler-combined pl-icon"></i>
      <div class="pl-body">
        <span class="pl-name">{{ option.set.name }}</span>
        <span class="pl-meta">
          <span class="pl-meta-item">
            <i class="fas fa-folder pl-meta-icon"></i>
            {{ categoryStore.getPathById(option.set.category) }}
          </span>
          @if (option.set.tags | tagSummary; as tags) {
            @if (tags.shown) {
              <span
                class="pl-meta-item"
                [pTooltip]="tags.rest ? tags.all : undefined">
                <i class="fas fa-tag pl-meta-icon"></i>
                {{ tags.shown }}
                @if (tags.rest) {
                  +{{ tags.rest }}
                }
              </span>
            }
          }
        </span>
      </div>
      @if (option.disabled) {
        <span
          class="pl-pill pl-pill-dashed"
          pTooltip="Teil der Auswahl – kann nicht Ziel sein.">
          in Auswahl
        </span>
      } @else {
        <span class="pl-pill">{{ childCount(option.set) }}</span>
      }
      <span class="pl-end">{{ unitLabel(option.set) }}</span>
    </div>
  </ng-template>
  <ng-template pTemplate="empty">
    <div class="pl-empty">Kein Set passt zum Filter.</div>
  </ng-template>
</p-listbox>
<p-divider></p-divider>
